import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProductCard from './ProductCard';

interface ProductsProps {
  onOpenLightbox: (images: string[], index: number) => void;
}

export default function Products({ onOpenLightbox }: ProductsProps) {
  const { t } = useTranslation();

  const product1Images = [
    'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/790f07b9373f7b078011f680fb226c14.jpeg',
    'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/c3c105fb807c83528cdd5be3da54cd55.jpeg',
    'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/cae46a998318c86cb4ccdfb6d2915414.jpeg',
    'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/049f082534260481c972af15b63b07de.jpeg',
    'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/0b528f7fa2c87a89d471b76b8f4a4f6b.jpeg'
  ];

  const product2Images = [
    'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/59973bb9ab02fdf7713ac159aef8808a.jpeg',
    'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/46e951a835e30b8c228f0525a536b59d.jpeg',
    'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/9096efe2ae5f0bcac926d41da2824dd2.jpeg',
    'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/637a99d3f0283f4c365aa23a66b70d27.jpeg',
    'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/31fbe301e15467e700de4aa821a82583.jpeg',
    'https://static.readdy.ai/image/bf3288118a626d850d67549d7636b7c2/c51db2a60f67a90be2a2cec70a5285b6.jpeg'
  ];

  const product1Specs = [
    { icon: 'ri-arrow-up-line', label: t('spec_work_height'), value: '60-100m' },
    { icon: 'ri-weight-line', label: t('spec_load_capacity'), value: '1.500-3.000kg' },
    { icon: 'ri-speed-line', label: t('spec_speed'), value: '0-45 m/min' },
    { icon: 'ri-building-line', label: t('spec_configuration'), value: '1-2 Cabines' },
    { icon: 'ri-layout-grid-line', label: t('spec_total_area'), value: '28,8 m²' },
    { icon: 'ri-checkbox-blank-line', label: t('spec_floor_area'), value: '4,5 m²' },
    { icon: 'ri-cube-line', label: t('spec_volume'), value: '9,9 m³' }
  ];

  const product2Specs = [
    { icon: 'ri-arrow-up-line', label: t('spec_tower_height'), value: '24 metros' },
    { icon: 'ri-building-2-line', label: t('spec_service_height'), value: 'Até 100m' },
    { icon: 'ri-weight-line', label: t('spec_max_capacity'), value: '5 toneladas' },
    { icon: 'ri-git-commit-line', label: t('spec_steel_cables'), value: '360 metros' }
  ];

  return (
    <section id="produtos" className="py-12 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Section Title */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('products_title')}
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto"></div>
        </div>

        <ProductCard
          title={t('product1_name')}
          images={product1Images}
          specs={product1Specs}
          accentColor="orange"
          safetyFeature={t('product1_safety_desc')}
          safetyTitle={t('product1_safety_title')}
          onOpenLightbox={onOpenLightbox}
        />

        <div className="my-12 sm:my-20 border-t border-gray-200"></div>

        <ProductCard
          title={t('product2_name')}
          images={product2Images}
          specs={product2Specs}
          accentColor="blue"
          accessories={t('product2_accessories_desc')}
          accessoriesTitle={t('product2_accessories_title')}
          onOpenLightbox={onOpenLightbox}
        />
      </div>
    </section>
  );
}